import axios from "axios";
import { urls } from "./Urls";
// import { getToken } from "../../../pages/Auth/User.service";

const formatSuccess = (res: any) => {
  return res.data;
};

const formatError = (err: any) => {
  if (err.code === "ERR_NETWORK") return "network error";
  return err.response.data.message;
};

const formatResponse = (data: any) => {
  return new Promise((resolve, reject) => {
    data
      .then((res: any) => resolve(formatSuccess(res)))
      .catch((err: any) => reject(formatError(err)));
  });
};

const getHeaders = () => {
  return {
    // Authorization: getToken(),
    // "api-key": "123456"
  };
};

export const getApi = (url: string, params: string = "") => {
  const headers = getHeaders();
  let axiosCall = axios.get(url + params, { headers });
  return formatResponse(axiosCall);
};

export const postApi = (url: string, json: any) => {
  const headers = getHeaders();
  let axiosCall = axios.post(url, json, { headers });
  return formatResponse(axiosCall);
};

export const putApi = (url: string, json: any) => {
  const headers = getHeaders();
  let axiosCall = axios.put(url, json, { headers });
  return formatResponse(axiosCall);
};

export const deleteApi = (url: string) => {
  const headers = getHeaders();
  let axiosCall = axios.delete(url, { headers });
  return formatResponse(axiosCall);
};

export const constants = { urls };
export { urls };
